export function pluralize(number, endings) {
  const n = Math.abs(number) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) {
    return endings[2];
  }
  if (n1 > 1 && n1 < 5) {
    return endings[1];
  }
  if (n1 === 1) {
    return endings[0];
  }
  return endings[2];
}

export function fitTextSize(text, defaultLength, baseSize, minSize) {
  if (!text) {
    return baseSize;
  }
  const extra = Math.max(0, text.length - defaultLength);
  return Math.max(minSize, baseSize - extra * 0.75);
}

export function trainingResultSummary(correct, total) {
  if (!total) {
    return '';
  }
  const percentSuccess = (correct / total) * 100;
  if (percentSuccess < 40) {
    return 'Нормальный старт. Повторите тренировку ещё раз, и сложные слова запомнятся заметно лучше.';
  }
  if (percentSuccess < 60) {
    return 'Уже лучше. Ошибки показывают, какие слова стоит закрепить прямо сейчас.';
  }
  if (percentSuccess < 90) {
    return 'Хороший темп. Ещё один короткий проход поможет довести ответы до автоматизма.';
  }
  return 'Отличный результат. Эти слова уже переходят в активный словарный запас.';
}

export function trainingSourceLabel(source) {
  switch (source) {
    case 'daily':
      return 'Слова на сегодня';
    case 'dictionary':
      return 'Тренировка словаря';
    case 'category':
      return 'Тренировка категории';
    default:
      return 'Тренировка слов';
  }
}

export function trainingPromptLabel(translationType) {
  return translationType === 'ru-en' ? 'Выберите слово на английском' : 'Выберите правильный перевод';
}

export function trainingEmptyStateText(source) {
  switch (source) {
    case 'daily':
      return 'Для тренировки нужно хотя бы 3 слова на сегодня.';
    case 'dictionary':
      return 'Добавьте в словарь хотя бы 3 слова, чтобы начать тренировку.';
    case 'category':
      return 'В этой категории пока недостаточно слов для тренировки.';
    default:
      return 'Тренировка пока недоступна.';
  }
}

export function achievementLockedDescription(achievement) {
  if (!achievement) {
    return '';
  }
  return `Достижение заблокировано. Выучите ${achievement.score} ${pluralize(achievement.score, ['слово', 'слова', 'слов'])}, чтобы получить достижение. Занимайтесь усердно каждый день, чтобы добиться успеха!`;
}
